// React for Website

import React from "react";
//outsource
import { Col, List } from "antd";

//components
import VoucherCard from "./voucher_card";

const refineData = (data, branches) => {
  const newData = data?.map((item) => {
    const address = branches?.find((row) => row.id === item?.branch)?.address;
    return {
      ...item,
      address,
    };
  });

  return newData;
};

const VoucherListing = ({ branches, data }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  const converted = refineData(data, branches);
  return (
    <List
      bordered
      dataSource={converted}
      renderItem={(item) => {
        return <VoucherCard data={item} />;
      }}
      pagination={{
        pageSize: 10,
      }}
    />
  );
};

export default VoucherListing;
